import React, { Fragment, useState, useEffect } from 'react'
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import FormAddRetention from './FormAddRetention';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Spinner from 'react-bootstrap/Spinner';
import AddRetentionType from './RetentionTypes/AddRetentionType';
import DataReactTableRetentions from './DataReactTableRetentions';
import { formatNumber } from '../../Utils/Money';


const RetentionSection = () => {
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [invoices, setInvoices] = useState(null);
    const [load, setLoad] = useState(true);
    const [loadTable, setLoadTable] = useState(false);
    const [retentions, setRetentions] = useState(null);
    const [retentionsTypeForm, setRetentionsTypeForm] = useState(false);
    const [retentionsTypeList, setRetentionsTypeList] = useState(null);
    const [retentionToAction, setRetentionToAction] = useState(null); //retencion que se va eliminar o actualizar
    const [onEdit, setOnEdit] = useState(false);
    const [isDelete, setIsdeleted] = useState(false);

    useEffect(() => {
        listInvoice();
        getRetentionsType();
        getRetentions();
    }, [])
    

    const listInvoice = async () => {
        setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.length > 0) {
                    console.log("FACTURAS", data);
                    setInvoices(data);
                }
                else {
                    setInvoices(null);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    const goToInvoice = async (num_fac_ter) => {
        try {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/consultar-por-numero', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ num_fac_ter: num_fac_ter })
            }).then(response => {
                return response.json();
            }).then(data => {
                if (data.factura != null) {
                    let factura = data.factura;
                    setSelectedInvoice(factura);
                    //setInvoiceInfo(factura);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
        catch (e) {
            console.log(e);
        }
    }

    //obtiene todos los tipos de retenciones guardados
    const getRetentionsType = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'tipo-retencion/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                setRetentionsTypeList(data)
            })
            .catch((error) => {
                console.log(error)
            })
    };

    const onSelectedInvoice = (e) => {
        //setPaymentById(null); //Borra la previsualizacion de los pagos
        setOnEdit(false);
        //setIncomeToPay(''); //reset al campo de importe a pagar 
        goToInvoice(e.target.value.num_fac_ter);
    }

    const getRetentions = async () => {
        setLoadTable(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                setLoadTable(false);
                filterRetentions(data);
                /* if (selectedInvoice !== null && selectedInvoice !== undefined) {
                    goToInvoice(selectedInvoice.num_fac_ter);
                } */
            })
            .catch((error) => {
                console.log(error)
            })
    };

    //discrimina las retenciones de los pagos
    const filterRetentions = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== false);
            setRetentions(resul);
        }
    }

    const searchNameRetentionType = (value) => {
        let name = ''
        if (retentionsTypeList !== null) {
            let ret = retentionsTypeList.find((typeRet) => typeRet.id_tipo_retencion === value.toString())
            name = ret.tipo_retencion;
        }
        return name
    }

    const reactTableDataRetentions = {
        tableHeaderData: [{
            Header: 'RETENCIÓN No.',
            accessor: 'id_pago',
            //disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'TIPO DE RETENCIÓN',
            accessor: 'tipo_retencion',
            Cell: row => (
                <label>{searchNameRetentionType(row.value)}</label>
            )
        },
        {
            Header: 'FACTURA',
            accessor: 'num_fac_ter',
        },
        {
            Header: 'VALOR',
            accessor: 'importe',
            Cell: row => (
                <label>${formatNumber(Math.ceil(row.value))}</label>
            )
        },
        {
            Header: 'NOTA',
            accessor: 'nota',
        },
        ],
        tableRowsData: retentions
    };

    const retentionToDelete = (retention) => {
        setIsdeleted(true);
        //setModalAlert({ title: 'Advertencia', color: 'warning', message: '¿Deseas eliminar esta Retención?' });
        goToInvoice(retention.num_fac_ter);
        setRetentionToAction(retention);
        console.log("ELIMINAR", retention )
    }

    const retentionToUpdate = (retention) => {
        setRetentionToAction(retention);
        setOnEdit(true);
        goToInvoice(retention.num_fac_ter);
    }

    const LoadInfo = () => {
        return (<DataReactTableRetentions
            reactTableData={reactTableDataRetentions}
            refresh={getRetentions}
            retentionToDelete={retentionToDelete}
            retentionToUpdate={retentionToUpdate}
        />)
    }

    return (
        <Fragment>
            <Card>
                <CardBody style={{ height: '100%' }}>
                    <Row>
                        <Col md={8}>
                            {
                                !load ?
                                    <TextField
                                        required
                                        select
                                        id="invoice-selected-required"
                                        label="Seleccione una Factura"
                                        type="text"
                                        className="medical-material-form__field"
                                        value={selectedInvoice}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        onChange={(e) => {
                                            onSelectedInvoice(e);
                                            console.log('EVENTO', e)
                                        }}
                                    >
                                        {invoices.map((invoice) => (
                                            <MenuItem key={invoice.num_fac_ter} value={invoice}>
                                                {invoice.num_fac_ter}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    :
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                        <div>
                                            <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                        </div>
                                    </div>
                            }
                        </Col>
                        <Col md={4}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                <Button
                                    color="primary"
                                    size='sm'
                                    onClick={() => {
                                        setRetentionsTypeForm(!retentionsTypeForm);
                                    }}
                                >
                                    {retentionsTypeForm ? "Cerrar Formulario" : "Agregar Tipo de Retención"}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={retentionsTypeForm ? 8 : 12}>
                            {
                                selectedInvoice &&
                                <FormAddRetention
                                    selectedInvoice={selectedInvoice}
                                    retentionsTypeList={retentionsTypeList}
                                    refresh={getRetentions}
                                    retentionToAction={retentionToAction}
                                    onEdit={onEdit}
                                    setOnEdit={setOnEdit}
                                    isDelete={isDelete}
                                    setIsdeleted={setIsdeleted} />
                            }
                        </Col>
                        <Col md={selectedInvoice ? 4 : 4}>
                            {
                                retentionsTypeForm ?
                                    <AddRetentionType setRetentionsTypeList={setRetentionsTypeList} />
                                    : null
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {
                                loadTable ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    : retentions &&
                                    <LoadInfo />

                            }
                        </Col>
                    </Row>

                </CardBody>
            </Card>
        </Fragment>
    )
}

export default RetentionSection